import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from '../../../../Grid/index.js';
import { Checkbox } from '../../../../index.js';
const Rubrik6 = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Row, null,
        React.createElement(Col, { width: "12" },
            React.createElement("h3", null, "Rubrik 6"),
            React.createElement(Checkbox, { style: { display: 'inline-block' }, placeholder: lang.documents.preventForkyndt, checked: !props.preventForkyndt, onChange: (e) => {
                    props.setDocumentState({
                        preventForkyndt: !e.target.checked,
                    });
                } }),
            React.createElement(Checkbox, { style: { display: 'inline-block' }, placeholder: lang.documents.preventAutDistress, checked: !props.preventAutDistress, onChange: (e) => {
                    props.setDocumentState({
                        preventAutDistress: !e.target.checked,
                    });
                } }),
            React.createElement(Checkbox, { style: { display: 'inline-block' }, placeholder: lang.documents.preventAutCivilCourt, checked: !props.notDirectlyToCivilCourt, onChange: (e) => {
                    props.setDocumentState({
                        notDirectlyToCivilCourt: !e.target.checked,
                    });
                } }))));
};
export default Rubrik6;
//# sourceMappingURL=Rubrik6.js.map